import { render, staticRenderFns } from "./SemaforosIns.vue?vue&type=template&id=57458f81"
import script from "./SemaforosIns.vue?vue&type=script&lang=js"
export * from "./SemaforosIns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports